import {
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput, showErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useState} from "react";
import {css} from "@emotion/css";
import RaikoFormFileSelector, {raikoFormFileTypes} from "../../component/raikoFormFileSelector/RaikoFormFileSelector";
import {stringIsEmpty} from "../../util/VariableChecker";
import {FormService} from "../../serverService/formService/FormService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function AddNewForm({handleAddNewFormToTable}) {

    const service = new FormService()

    const [title, setTitle] = useState("")

    const [pdfFile, setPdfFile] = useState()
    const [pdfFileName, setPdfFileName] = useState();
    const [pdfProgress, setPdfProgress] = useState(0);
    const [pdfLoadingState, setPdfLoadingState] = useState(false)

    const [wordFile, setWordFile] = useState();
    const [wordFileName, setWordFileName] = useState();
    const [wordProgress, setWordProgress] = useState(0)
    const [wordLoadingState, setWordLoadingState] = useState(false)

    const loading = new LoadingHelper(useLoadingDispatcher())

    function handleAddForm() {
        if (checkFields()) {
            loading.show()

            service.addNewFormInfo(
                title,
                pdfFile,
                setPdfProgress,
                setPdfLoadingState,
                wordFile,
                setWordProgress,
                setWordLoadingState
            ).then(response => {
                showSuccessMessage("فرم جدید با موفقیت افروده شد.")
                handleAddNewFormToTable(response)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let message
        let status = false

        if (stringIsEmpty(title)) {
            message = "لطفا نام فرم را به درستی وارد نمایید."
        } else if (!pdfFile && !wordFile) {
            message = "لطفاحداقل یکی از انواع فرم را انتخاب نمایید."
        } else
            status = true

        if (message)
            showWarningMessage(message)

        return status

    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoMaterialOutlinedInput labelText={"عنوان"} value={title} setValue={setTitle}/>

            <RaikoFormFileSelector
                setFileName={setPdfFileName}
                fileName={pdfFileName}
                file={pdfFile}
                setFile={setPdfFile}
                progress={pdfProgress}
                loading={pdfLoadingState}
                formType={raikoFormFileTypes.PDF_FILE}
            />
            <RaikoFormFileSelector
                setFileName={setWordFileName}
                fileName={wordFileName}
                file={wordFile}
                setFile={setWordFile}
                progress={wordProgress}
                loading={wordLoadingState}
                formType={raikoFormFileTypes.WORD_FILE}
            />

            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={"افزودن"} onClick={handleAddForm}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}